export function FineReasonDescription(data) {
    let files;

    if (data.bonusFiles && data.bonusFiles.length) {
        files = data.bonusFiles;
    } else {
        files = data.fineFiles;
    }
    
    const {
        id,
        text: description,
        link,
    } = data;

    return {
        id,
        description: description || "",
        link: link || "",

        files: (files || []).map((file) => {
            const { id, name } = file;

            return {
                id,
                url: name,
                name: name.split("/").pop(),
            };
        }),

        hasDescription: description || link || (files && files.length),
    };
}

export function FineReason(data) {
    const {
        id,
        description: name,
        category_id: category,
        postFines: positions,
        amount_fine: amount,
        period_id: period,
        repeat_with_category: countRepeats,
        repeatFines: repeats,
        doubling,
    } = data;

    return {
        id,
        name: name || "",
        category,
        positions,
        amount,
        period,
        countRepeats: !!countRepeats,
        repeats: (repeats || []).map((repeat) => ({
            count: repeat.repeat || "",
            amount: repeat.amount_fine || "",
        })),
        doubling,

        ...FineReasonDescription(data),
    };
}

export function formatFineReason(data) {
    const {
        id,
        name,
        description,
        link,
        category,
        amount,
        period,
        countRepeats,
        repeatType,
        repeats,
        positions,
        files,
        oldFiles,
    } = data;

    const filteredRepeats = repeats.filter(rep => rep.amount && rep.count);
    const newRepeats = filteredRepeats.map((repeat) => ({
        repeat: repeat.count,
        amount_fine: repeat.amount,
    }));

    const params = {
        description: name,
        category_id: category,
        post_code: positions,
        amount_fine: amount,
        period_id: period,
        repeat_with_category: countRepeats ? 1 : 0,
        repeat_fine: newRepeats,
        doubling: repeatType === 3 ? 1 : 0,
        files,
        oldFiles,
        text: description,
        link,
    };

    if (id) params.id = id;

    return params;
}
